import React from "react";
import {MainLayout} from "../../layouts/MainLayout";
import {useNavigate, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import {allPayrollStatus, FETCH_STATUS_IDLE, FETCH_STATUS_LOADING} from "../../utils/constants";
import {useTranslation} from "react-i18next";
import useFetchPayrolls from "../../hooks/useFetchPayrolls";
import {PopupLoading, PopupWithMessage, StatusStepper} from "../../components";
import {
    allPayrollsFetchError,
    allPayrollsFetchState,
    selectPayrollById,
    updatePayrollError
} from "../../app/payroll/selectors";
import {PayrollPageContent, PayrollPageHeader} from "./styles";
import {fullNameForUser, isCompletePayroll} from "../../utils";
import {selectAdminUser} from "../../app/adminUser/selectors";
import PayrollStatusExplanation from "./components/PayrollStatusExplanation";
import PayrollActions from "./components/PayrollActions";

export const Payroll = () => {
    useFetchPayrolls()

    const admin = useSelector(selectAdminUser)
    const params = useParams()
    const id = params.id || ''

    const payroll = useSelector(selectPayrollById(id))

    const payrollUpdateError = useSelector(updatePayrollError);
    const payrollFetchError = useSelector(allPayrollsFetchError);
    const payrollFetchState = useSelector(allPayrollsFetchState);

    const { t } = useTranslation();
    const navigate = useNavigate();

    if (
        payrollFetchState === FETCH_STATUS_IDLE ||
        payrollFetchState === FETCH_STATUS_LOADING

    ) {
        return <MainLayout>
            <PopupLoading isOpen={true} />
        </MainLayout>
    }

    if(payrollFetchError || !payroll || payrollUpdateError){
        const errorMessage = payrollFetchError || payrollUpdateError || t('error_retrieving_payrolls') as string
        return (
            <MainLayout>
                <PopupWithMessage
                    isOpen={true}
                    title={t('error_message_title') as string}
                    subtitle={errorMessage}
                    buttonTitle={'Ok'}
                    buttonAction={() => navigate('/employees')}
                    type="error"
                />
            </MainLayout>
        );
    }

    if(!isCompletePayroll(payroll)){
        return (
            <MainLayout>
                <PopupWithMessage
                    isOpen={true}
                    title={t('error_message_title') as string}
                    subtitle={t('error_payroll_incomplete_data') as string}
                    buttonTitle={'Ok'}
                    buttonAction={() => navigate('/employees')}
                    type="error"
                />
            </MainLayout>
        );
    }

    const companyName = payroll.company.name;
    const employeeName = fullNameForUser(payroll.eor_employee);
    const payrollData = new Date(payroll.created).toLocaleDateString(admin.locale || 'en', {month: 'long', year: 'numeric'})

    return <MainLayout>
        <PayrollPageContent>
            <PayrollPageHeader>
                <h1> {t('payroll_title', {companyName, employeeName, payrollData}) as string} </h1>
                <h2> {companyName} </h2>
            </PayrollPageHeader>
            <StatusStepper
                steps={ allPayrollStatus.map((s) => t(s) as string) }
                currentStep={allPayrollStatus.indexOf(payroll.status)}
            />
            <PayrollStatusExplanation payroll={payroll}/>
            <PayrollActions payroll={payroll}/>
        </PayrollPageContent>
    </MainLayout>
}

export default Payroll;
